var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateUserPageViewActionAction } from '@/actions/AnalyticsActions';
import { logError } from '@/helpers/logger';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * ページビューログに紐づくIDに対し、さらなるアクションログを追加するuse
 */
export const usePageViewAction = (args) => {
    const { action, actionId: baseActionId, subAction } = args;
    const dispatch = useDispatch();
    const { pageViewId } = useTypeSelector((state) => state.analytics);
    /**
     * ページビューログに紐づくアクションログを追加
     */
    const createUserPageView = useCallback((id) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // ページビューIDが存在しない場合、何もしない
        if (!pageViewId) {
            return;
        }
        const actionId = `${(_a = id !== null && id !== void 0 ? id : baseActionId) !== null && _a !== void 0 ? _a : ''}`;
        try {
            yield wrapDispatch(dispatch, apiCreateUserPageViewActionAction({
                json: {
                    action,
                    actionId,
                    subAction,
                },
                path: { id: pageViewId },
            }, {}));
        }
        catch (e) {
            // エラーログを記録しつつ握り潰しておく
            logError(e);
        }
    }), [action, baseActionId, dispatch, pageViewId, subAction]);
    return {
        createUserPageView,
    };
};
